<div class="container mb-5">
        <div class="row">
          <div class="col-sm-2">
            <!-- <app-dashmenu></app-dashmenu> -->
          </div>
          <div class="col-sm-10">
            <div class="alert alert-danger" *ngIf="errorRequired">
              Tous les champs sont obligatoires
            </div>
            <div class="card">
              <div class="card-body py-4" *ngIf="!isConfirm">
                <div class="row g-3 mesInfos">
                  <div class="col-md-5" *ngIf="typeCompte == 'B2B'">
                    <label for="email"  class="form-label">ICE <span class="text-danger">*</span></label>
                    <input type="email" [(ngModel)]="profile.ice" (keypress)="numberOnly($event)" (blur)="checkRc()" class="form-control" [class.is-invalid] = "errorRC" id="email">
                    <div class="invalid-feedback">
                      ICE doit contenir 15 caractères
                    </div>
                  </div>
                  <div class="col-md-5">
                    <label for="nom"  class="form-label">Nom et Pénom <span class="text-danger">*</span></label>
                    <input type="email" [(ngModel)]="profile.name"  class="form-control" id="nom">
                  </div>
                  <div class="col-md-5">
                    <label for="email"  class="form-label">Adresse <span class="text-danger">*</span></label>
                    <input type="email" [(ngModel)]="profile.adresse"  class="form-control" id="email">
                  </div>
                  <div class="col-md-5">
                    <label for="email"  class="form-label">Référence client <span class="text-danger">*</span></label>
                    <input type="email" [(ngModel)]="profile.ref"  class="form-control" id="email">
                  </div>
                  <div class="col-md-5">
                    <label for="email"  class="form-label">Adresse (suit)</label>
                    <input type="email" [(ngModel)]="profile.adresseSuit"  class="form-control" id="email">
                  </div>
                  <div class="col-md-5">
                    <label for="email"  class="form-label">E-mail <span class="text-danger">*</span></label>
                    <input type="email" [(ngModel)]="profile.email" (blur)="checkEmail()" class="form-control" [class.is-invalid] = "errorEmail" id="email">
                    <div class="invalid-feedback">
                      Format d'adresse email invalide
                    </div>
                  </div>
                  <div class="col-md-5">
                    <label for="email"  class="form-label">Ville <span class="text-danger">*</span></label>
                    <input type="email" [(ngModel)]="profile.ville"  class="form-control" id="email">
                  </div>
                  <div class="col-md-5">
                    <label for="email"  class="form-label">Télephone <span class="text-danger">*</span></label>
                    <input type="email" [(ngModel)]="profile.tel" (keypress)="numberOnly($event)" (blur)="checkPhone()"  [class.is-invalid] = "errorPhone" class="form-control" id="email">
                    <div class="invalid-feedback">
                      Format téléphone invalide
                    </div>
                  </div>
                </div>
                <div class="row g-3 mesInfos">
                  <div class="col-md-5">
                    <a routerLink="/panier"><button type="button" name="button" class="acceuilBtnCats mt-3">Retour au panier</button></a>
                  </div>
                  <div class="col-md-5">
                    <button type="button" (click)="confirm()" name="button" class="acceuilBtnCats mt-3" *ngIf="!sendOrder">Enregistrer et confirmer</button>
                    <button type="button"  name="button" class="acceuilBtnCats mt-3" *ngIf="sendOrder"><i class="fa fa-spinner fa-spin fa-3x"></i> Enregistrer et confirmer</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-dialog modal-dialog-centered" *ngIf="isConfirm" >
          <div class="modal-content">
            <div class="modal-body text-center">
              <img src="assets/front/images/valide.gif" class="img-fluid">
              <h5 class="validationTitle">La commande a été confirmée avec succès</h5>
            </div>
          </div>
        </div>
</div>

<!-- <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#confirmModal">
 Popup Confirmation
</button> -->

<!-- <div class="modal fade"  id="confirmModal" tabindex="-1" aria-labelledby="confirmModal" aria-hidden="true"> -->
  <!-- <div class="modal-dialog modal-dialog-centered" *ngIf="isConfirm" >
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center">
        <img src="assets/front/images/valide.gif" class="img-fluid">
        <h5 class="validationTitle">Les Modifications ont été effectuées avec succès</h5>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
      </div>
    </div>
  </div> -->
<!-- </div> -->
